import { ListGroup } from 'react-bootstrap'
import RecordingTableItem from './RecordingTableItem'
import { useContext } from 'react'
import { PlayerContext } from '../../pages/Home'

const RecordingTable = ({ hide, recordingList }) => {
  const { playRecordings } = useContext(PlayerContext)

  if (!recordingList) return ''

  const playFn = (index) => {
    playRecordings(recordingList, index)
  }

  return (
    <>
      <ListGroup>
        {recordingList.map((recording, i) => (
          <RecordingTableItem
          hide={hide}
            recording={recording}
            key={recording.name}
            index={i}
            playFn={playFn}
          />
        ))}
      </ListGroup>
    </>
  )
}
export default RecordingTable
